import styled from 'styled-components';

const Focus = styled.div`
  max-width: 70%;
  padding: 0 16px;
  margin: auto;

  @media (max-width: 992px) {
    max-width: 85%;
  }
`;

const SectionTitle = styled.h2`
  display: flex;
  justify-content: center;

  margin-bottom: 30px;
`;

const Lead = styled.p`
  font-size: 16px;
  text-align: center;
  max-width: 720px;
  margin: 0 auto 28px;
`;

const Areas = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Area = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  background-color: white;
  box-shadow: 1px 1px 2px 1px #181818;
  border-radius: 12px;
  padding: 16px;

  h4 {
    font-size: 16px;
    font-weight: bold;
  }

  span {
    font-size: 14px;
  }
`;

const SubTitle = styled.h3`
  font-size: 18px;
  margin: 32px 0 12px;
`;

const WorkItem = styled.div`
  font-size: 14px;

  a {
    font-weight: 600;
  }
`;

const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  margin-top: 28px;
  font-size: 14px;
  font-weight: 600;
`;

const areas = [
  {
    title: '🧪 AI evals',
    description:
      'Human-eval quality gates, LLM-as-judge loops and cost/quality trade-offs, so a pipeline can be trusted to run without a human in the loop.',
  },
  {
    title: '🚰 Data pipelines',
    description:
      'Distributed batch and streaming pipelines that turn raw, messy data into structured knowledge bases feeding RAG, fine-tuning and eval loops.',
  },
  {
    title: '🎬 Multimodal content understanding',
    description:
      'Vision-language embeddings, frame extraction and searchable indexes over video, image and audio content.',
  },
  {
    title: '🛠️ Product engineering',
    description:
      'Shipping user-facing products end to end: real-time systems, internationalisation and payments at scale, 10+ years of Java, plus Ruby, Python and TypeScript/React.',
  },
];

export default () => {
  return (
    <Focus id="now">
      <SectionTitle>Now</SectionTitle>
      <Lead>
        I build AI-enabled content and quality systems at scale: the pipelines that produce content, and the evals that
        decide whether it is good enough to ship.
      </Lead>

      <Areas>
        {areas.map((area) => (
          <Area key={area.title}>
            <h4>{area.title}</h4>
            <span>{area.description}</span>
          </Area>
        ))}
      </Areas>

      <SubTitle>Selected AI/ML work</SubTitle>
      <WorkItem>
        <a href="https://goagentic.dev" target="_blank" rel="noreferrer">
          GoAgentic
        </a>{' '}
        is a destination-intelligence platform for tourism boards: an eval harness that measures what AI assistants can
        actually answer about a destination, a pipeline that collects the missing supplier data at the source, and a
        weekly re-measurement loop that shows the gap closing.
      </WorkItem>

      <Links>
        <a href="https://www.linkedin.com/in/jotamartins/" target="_blank" rel="noreferrer">
          LinkedIn ↗
        </a>
        <a href="https://www.producthunt.com/products/say-my-name" target="_blank" rel="noreferrer">
          SayMyName on Product Hunt ↗
        </a>
        <a href="https://www.producthunt.com/products/zapzipped" target="_blank" rel="noreferrer">
          ZapZipped on Product Hunt ↗
        </a>
      </Links>
    </Focus>
  );
};
